<template lang="pug">
#approvalContainer
  .approval
    el-tabs(v-model="activeName")
      el-tab-pane(label="新建流程" name="1")
      el-tab-pane(label="我的审批" name="2")
      el-tab-pane(label="我的创建" name="3")
    .list
      newApproval(ref="newApproval" v-if="activeName==='1'")
      myApplication(ref="myApplication" v-if="activeName==='2'")
      myCreate(ref="myCreate" v-if="activeName==='3'")
</template>

<script>
import newApproval from "./components/newApproval.vue";
import myApplication from "./components/myApplication.vue";
import myCreate from "./components/myCreate.vue";
export default {
  name: "ExamineApprove",
  components: { newApproval, myApplication, myCreate },
  data () {
    return {
      activeName: "1"
    };
  }
};
</script>

<style lang="scss" scoped>
#approvalContainer {
  width: 100%;
  height: 100%;
  padding: var(--middle-space);
}
.approval{
  width: 100%;
  height: 100%;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  .el-tabs{
    padding: 0 var(--big-space);
    background-color: #fff;
    border-radius: 5px;
    /deep/.el-tabs__header{
      margin-bottom: 2px !important;
    }
  }
  /deep/ .el-tabs__nav-wrap::after{
    background-color:#fff
  }
  .list{
    width: 100%;
    height: 1px;
    flex-grow: 1;
    margin-top: var(--middle-space);
  }
}
::v-deep .el-tabs__nav-wrap::after {
  height: 0 !important;
}
</style>
